import React from 'react';
import PropTypes from 'prop-types';
import TileGrid from 'components/TileGrid';
import List from 'components/List';

export const getTileGridButtons = ({ theme, expanded, toggleFunction, toggleMoreTextOverride }) => {
  const {
    paginationLessButton: toggleLessText,
    paginationMoreButton: toggleMoreText,
  } = window.Language;
  const seeMoreText = toggleMoreTextOverride || toggleMoreText;
  const caption = expanded ? toggleLessText : seeMoreText;
  return (
    <div className={theme.buttonsContainer}>
      <button onClick={toggleFunction} className={theme.button} type="button">
        {caption}
      </button>
    </div>
  );
};

const getTileGridButtonsAll = ({ theme, expanded, toggleFunction }) => {
  const { tileGrid_seeAllButtonText: seeAllText } = window.Language;
  return getTileGridButtons({
    theme,
    expanded,
    toggleFunction,
    toggleMoreTextOverride: seeAllText,
  });
};

export function renderGrid({
  collectionType,
  context,
  gridProcessor,
  gridType,
  isAuthenticated,
  items,
  itemsCollapsed,
  key,
  listProcessor,
  listTheme,
  onLinkClick,
  onPlayClick,
  onTileClick,
  onTitleClick,
  onToggleShowMore,
  paginationLessButton,
  paginationMoreButton,
  preauthorizedResources,
  renderImage,
  renderList,
  scrollSeeLess,
  shouldRenderButtons,
  showSeriesName,
  style,
  tileDetailToggle,
  tileGridTheme,
  tileGridTrackButtonClick,
  tileIndexOffset,
  tileTheme,
  tileType,
  toggleLimit,
  expandBehavior,
}) {
  const getTileGridButtonsCall = getTileGridButtonsAll;
  const getButtons = shouldRenderButtons ? getTileGridButtonsCall : null;
  if (renderList) {
    return (
      <List
        key={key}
        theme={listTheme}
        items={items}
        processor={listProcessor}
        onLinkClick={onLinkClick}
        tileDetailToggle={tileDetailToggle}
        onTitleClick={onTitleClick}
        onPlayClick={onPlayClick}
        tileTheme={tileTheme}
        toggleLimit={toggleLimit}
        toggleMoreText={paginationMoreButton}
        toggleLessText={paginationLessButton}
      />
    );
  }
  return (
    <TileGrid
      collectionType={collectionType}
      context={context}
      expandBehavior={expandBehavior}
      getButtons={getButtons}
      gridType={gridType}
      isAuthenticated={isAuthenticated}
      items={items}
      itemsCollapsed={itemsCollapsed}
      key={key}
      onTileClick={onTileClick}
      onTitleClick={onTitleClick}
      onToggleShowMore={onToggleShowMore}
      preauthorizedResources={preauthorizedResources}
      processor={gridProcessor}
      renderImage={renderImage}
      scrollSeeLess={scrollSeeLess}
      showSeriesName={showSeriesName}
      style={style}
      theme={tileGridTheme}
      tileDetailToggle={tileDetailToggle}
      tileGridTrackButtonClick={tileGridTrackButtonClick}
      tileIndexOffset={tileIndexOffset}
      tileTheme={tileTheme}
      tileType={tileType}
      toggleLessText={paginationLessButton}
      toggleLimit={toggleLimit}
      toggleMoreText={paginationMoreButton}
    />
  );
}

renderGrid.defaultProps = {
  collectionType: null,
  context: null,
  expandBehavior: () => {},
  isAuthenticated: false,
  itemsCollapsed: true,
  key: null,
  listTheme: null,
  onLinkClick: null,
  onPlayClick: () => {},
  onTileClick: null,
  paginationLessButton: null,
  paginationMoreButton: null,
  preauthorizedResources: null,
  scrollSeeLess: null,
  shouldRenderButtons: null,
  showSeriesName: false,
  tileGridTheme: null,
  tileGridTrackButtonClick: () => {},
  toggleLimit: null,
};

renderGrid.propTypes = {
  collectionType: PropTypes.string,
  context: PropTypes.shape({}),
  expandBehavior: PropTypes.func,
  gridProcessor: PropTypes.func.isRequired,
  gridType: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itemsCollapsed: PropTypes.bool,
  key: PropTypes.string,
  listProcessor: PropTypes.func.isRequired,
  listTheme: PropTypes.string,
  onLinkClick: PropTypes.func,
  onPlayClick: () => {},
  onTileClick: PropTypes.func,
  onTitleClick: PropTypes.func.isRequired,
  onToggleShowMore: PropTypes.func.isRequired,
  paginationLessButton: PropTypes.shape({}),
  paginationMoreButton: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  renderImage: PropTypes.func.isRequired,
  renderList: PropTypes.bool.isRequired,
  scrollSeeLess: PropTypes.bool,
  shouldRenderButtons: PropTypes.bool,
  showSeriesName: PropTypes.bool,
  style: PropTypes.shape({}).isRequired,
  tileDetailToggle: PropTypes.bool.isRequired,
  tileGridTheme: PropTypes.string,
  tileGridTrackButtonClick: PropTypes.func,
  tileIndexOffset: PropTypes.number.isRequired,
  tileTheme: PropTypes.shape({}).isRequired,
  tileType: PropTypes.string.isRequired,
  toggleLimit: PropTypes.bool,
};

getTileGridButtons.defaultProps = {
  theme: {},
  expanded: false,
  toggleFunction: () => {},
  toggleMoreTextOverride: () => {},
};

getTileGridButtons.propTypes = {
  theme: PropTypes.shape({}),
  expanded: PropTypes.bool,
  toggleFunction: PropTypes.func,
  toggleMoreTextOverride: PropTypes.func,
};
